import { useGetMessagesForStudentQuery } from "../messageApiSlice"
import Message from "./Message"
import useAuth from "../../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const MyMessages = () => {
    const {groupId} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: messages,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetMessagesForStudentQuery('messagesStudentList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })




    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess ) {     
        if(!messages.length) return <h3 style={{paddingTop:"20px"}}>אין הודעות להצגה</h3>

        let filtered = []
        if((groupId!=='0')){
            filtered=[...messages].filter(message =>{
             return ((groupId==='0' || message.group?._id === groupId ))

            })
        }else
            {
                filtered = [...messages]
            }

        content = (
            <>
            {filtered.map(message => <Message key={message._id} message={message} />)}
            </>
        )
    }

    return content
}
export default MyMessages